import { useCallback } from 'react';
import { useTutorialProgress } from './useTutorialProgress';

export const useSettingsCompletion = (formData, onSave) => {
  const { completeCurrentStep } = useTutorialProgress();

  const handleSave = useCallback(async (...args) => {
    const result = await onSave(...args);

    if (result !== false) {
      completeCurrentStep(formData);
    }

    return result;
  }, [completeCurrentStep, formData, onSave]);

  return {
    handleSave,
  };
};

export default useSettingsCompletion;
